import * as uuid from 'uuid';
export const generatePromptId = () => uuid.v4();
export const toAssistantPrompts = (instructions = [], idFactory = generatePromptId) => instructions.map((instruction) => {
    const existingId = instruction.promptId;
    return {
        ...instruction,
        promptId: existingId || idFactory(),
    };
});
export const createEmptyInstruction = (role, idFactory = generatePromptId) => ({
    type: role,
    content: '',
    promptId: idFactory(),
});
export const copyInstructionById = (instructions, promptIdToCopy, idFactory = generatePromptId) => {
    const instructionToCopy = instructions.find((i) => i.promptId === promptIdToCopy);
    if (!instructionToCopy) {
        return instructions;
    }
    return [
        ...instructions,
        {
            ...instructionToCopy,
            promptId: idFactory(),
        },
    ];
};
export const removeInstructionById = (instructions, promptIdToRemove) => instructions.filter((instruction) => instruction.promptId !== promptIdToRemove);
/**
 * Compare two prompt types
 */
const typesEqual = (a, b) => {
    return a.type === b.type;
};
/**
 * Compare content if both prompts have it
 */
const contentsEqual = (a, b) => {
    const aContent = 'content' in a ? a.content : undefined;
    const bContent = 'content' in b ? b.content : undefined;
    return aContent === bContent;
};
/**
 * Compare config objects for memory-type prompts
 */
const configsEqual = (a, b) => {
    const aConfig = 'config' in a ? a.config : undefined;
    const bConfig = 'config' in b ? b.config : undefined;
    // Both undefined
    if (aConfig === undefined && bConfig === undefined) {
        return true;
    }
    // One undefined
    if (aConfig === undefined || bConfig === undefined) {
        return false;
    }
    // Deep equality check for config properties
    return aConfig.length === bConfig.length && aConfig.order === bConfig.order;
};
/**
 * Compare promptId if present (for assistantPrompt comparison)
 */
const promptIdsEqual = (a, b) => {
    const aId = a.promptId || '';
    const bId = b.promptId || '';
    return aId === bId;
};
/**
 * Compare two individual prompts for equality
 */
const promptsEqual = (a, b) => {
    return (typesEqual(a, b) &&
        contentsEqual(a, b) &&
        configsEqual(a, b) &&
        promptIdsEqual(a, b));
};
/**
 * Compare two arrays of prompts for deep equality
 * @returns true if arrays contain identical prompts in the same order
 */
export const instructionsEqual = (first = [], second = []) => {
    // Early returns for reference equality and length mismatch
    if (first === second) {
        return true;
    }
    if (first.length !== second.length) {
        return false;
    }
    // Compare each prompt pair
    return first.every((promptA, index) => promptsEqual(promptA, second[index]));
};
